'use strict';

export { isValidRubberBandConfig, SLOPE_FACTOR } from "./utilsCommon.js";
export const VELOCITY_EPS = 1 / 20;
//# sourceMappingURL=utils.js.map